const getReplacementTextAt = (blockText, position, trigger) => {
  let str = blockText.substr(0, position);

  // TODO: Find last a past of mention text on the selected mention
  const lastStr = blockText.substr(position);
  const aPartOfMentionRegex = /[a-zA-Z.\s]*(})/i;
  const matchResult = lastStr.match(aPartOfMentionRegex);
  if (typeof matchResult !== 'undefined' && matchResult !== null) {
    str = str + matchResult[0];
  }

  const begin = trigger.length === 0 ? 0 : str.lastIndexOf(trigger);
  const matchingString = trigger.length === 0 ? str : str.slice(begin + trigger.length);
  const end = str.length;

  return {
    begin,
    end,
    matchingString,
  };
};

export default (editorState, selection, trigger) => {
  const anchorKey = selection.getAnchorKey();
  const anchorOffset = selection.getAnchorOffset();
  const currentContent = editorState.getCurrentContent();
  const currentBlock = currentContent.getBlockForKey(anchorKey);
  const blockText = currentBlock.getText();
  return getReplacementTextAt(blockText, anchorOffset, trigger);
};
